import React from "react";
import { AlertCircle, X, Power, CheckCircle2 } from "lucide-react";

export function StatusConfirmModal({ isOpen, onClose, onConfirm, employeeName, currentStatus }) {
  if (!isOpen) return null;

  const isDeactivating = currentStatus === "active";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop blur */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200" onClick={onClose} />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden animate-in fade-in zoom-in-95 duration-200 border border-slate-100">
        
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute right-4 top-4 p-1.5 rounded-lg hover:bg-slate-50 text-slate-400 hover:text-slate-600 transition-colors"
          title="Close Dialog"
        >
          <X className="w-4 h-4" />
        </button>

        {/* Content */}
        <div className="p-6 text-center">
          {/* Status Icon */}
          {isDeactivating ? (
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-500 flex items-center justify-center mx-auto mb-4 border border-amber-100">
              <AlertCircle className="w-5 h-5 animate-pulse" />
            </div>
          ) : (
            <div className="w-12 h-12 rounded-full bg-emerald-50 text-emerald-500 flex items-center justify-center mx-auto mb-4 border border-emerald-100">
              <CheckCircle2 className="w-5 h-5 animate-pulse" />
            </div>
          )}

          <h3 className="text-[15px] font-bold text-slate-800">
            {isDeactivating ? "Deactivate Employee" : "Activate Employee"}
          </h3>
          <p className="text-[12px] text-slate-500 mt-2 leading-relaxed">
            {isDeactivating 
              ? `Are you sure you want to deactivate ${employeeName}? They will no longer be able to log in, mark attendance, or receive salaries.`
              : `Are you sure you want to activate ${employeeName}? Their account access and directory presence will be restored.`}
          </p>
        </div>

        {/* Action Footer */}
        <div className="px-6 py-4 bg-slate-50/50 border-t border-slate-100 flex items-center justify-end gap-3">
          <button 
            onClick={onClose} 
            className="btn-secondary py-2 text-[12px] font-semibold text-slate-600"
          >
            Cancel
          </button>
          <button 
            onClick={() => {
              onConfirm();
              onClose();
            }} 
            className={`btn-primary py-2 px-4 text-[12px] font-semibold flex items-center gap-1.5 border-none shadow-sm transition-all hover:scale-[1.01] ${
              isDeactivating 
                ? "bg-amber-600 hover:bg-amber-700 text-white" 
                : "bg-emerald-600 hover:bg-emerald-700 text-white"
            }`}
          >
            <Power className="w-3.5 h-3.5" />
            {isDeactivating ? "Deactivate" : "Activate"}
          </button>
        </div>

      </div>
    </div>
  );
}
